import api from "../../utils/api";

export const getAllOrdersOfUser = (userId, page, limit, sortBy, restaurantId) => async (dispatch, getState) => {
  console.log("🚀 ~ getAllOrdersOfUser ~ userId, page, limit, sortBy:", userId, page, limit, sortBy, restaurantId);

  try {
    const state = getState();
    const cleanRestaurantId = restaurantId?.replace(/^"|"$/g, "");
    // Generate a unique key for this request
    const cacheKey = `${userId}-${page}-${limit}-${sortBy}-${cleanRestaurantId}`;
    const cachedOrders = state.order.ordersCache?.[cacheKey] || null;

    // If orders are cached, return cached data
    if (cachedOrders) {
      console.log("order case trigger")
      dispatch({
        type: "getAllOrderUserCached",
        payload: cachedOrders,
      });
      return;
    }

    // If no cached data, make the API call
    dispatch({ type: "getAllOrderUserRequest" });

    const { data } = await api.get("/order", {
      params: { userId, page, limit, sortBy,  restaurantId: cleanRestaurantId || undefined },
    });
    // console.log("🚀 ~ getAllOrdersOfUser ~ data:", data)


    // Store data in the cache and dispatch success
    dispatch({
      type: "getAllOrderUserSuccess",
      payload: { data, cacheKey },
    });
  } catch (error) {
    console.error("Error during API call:", error);
    dispatch({
      type: "getAllOrderUserFail",
      payload: error.response ? error.response.data.message : error.message,
    });
  }
};
